"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("userMenuSwitchVueClient", function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./userMenuSwitchVueClient.html"),
    controller: function controller($scope, $http, routeUtils) {
      $scope.switchVueClient = function () {
        $http.post('/rest/home/switch-vue-client-intra').then(function () {
          routeUtils.reloadApp();
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/topbar/user-menu/actions/userMenuSwitchVueClient.js
// module id = 3025
// module chunks = 13